import { QueryClient, useMutation } from "@tanstack/react-query";
import { ApiErrorResponse } from "../models/ApiResponse";
import { apiStore } from "../stores/api.store";
import { toast } from "../utils/toast";

export const queryClient = new QueryClient();

interface CreateArbetsgivarintygRequest {
	consultantId: string;
	hasConsultantAllowedTransmit: boolean;
	sendSms?: boolean;
	endReason?: string; // own-request or reason
	range: { start: Date; end: Date };
}

export function useSendArbetsgivarIntyg() {
	return useMutation<any, ApiErrorResponse, CreateArbetsgivarintygRequest>(
		(params) =>
			apiStore
				.post({
					path: `/integration/arbetsgivarintyg`,
					body: params,
					isAuthRequired: true,
				})
				.then((d) => d.data),

		{
			onSuccess: () => {
				toast.success("Arbetsgivarintyg skapades");
			},
			onError: (error) => {
				toast.error("Kunde ej skapa arbetsgivarintyg");
			},
		}
	);
}
